(function () {
  angular
    .module('specsguardApp')
    .controller('sgTableFilterCtrl', sgTableFilterCtrl);

  sgTableFilterCtrl.$inject = ['$scope'];

  function sgTableFilterCtrl ($scope) {
    const vm = this;
    vm.column = $scope.column;

    /**
     * Opens menu with $mdMenu, but first resets the menu's settings
     */
    vm.openMenu = ($mdMenu, $event) => {
      vm.$onInit();
      $mdMenu.open($event);
    };

    vm.$onInit = () => {
      vm.column.optionDisplayKey = angular.isDefined(vm.column.optionDisplayKey) ? vm.column.optionDisplayKey : 'value';
      vm.column.optionValueKey = angular.isDefined(vm.column.optionValueKey) ? vm.column.optionValueKey : 'value';

      // Included when using the checkbox filter
      if (vm.column.type === 'multiSelect') {

        // Workaround, make sure we only have unique filter options
        vm.column.filterData = vm.column.filterData.filter((thing, index, self) =>
          index === self.findIndex((t) => (
            t._id === thing._id
          ))
        );

        //set .selected and .selectedProxy to true if it is undefined, otherwise just keep .selected value
        vm.column.filterData.forEach((item) =>
          item.selected = item.selectedProxy = (item.selected === false) ? false : true);
        vm.column.isAllSelected = true;
      }
    };

    vm.column.exists = (element, list) => list.find((item) => item.displayName === element);

    // multiSelect
    vm.toggleAll = function () {
      vm.column.isAllSelected = !vm.column.isAllSelected;
      vm.column.filterData.forEach((item) => {
        item.selectedProxy = vm.column.isAllSelected;
      });
    };

    /**
     * Returns if there is any selection done in the checkbox list
     */
    vm.hasSelection = function () {
      return vm.column.filterData.some((x) => x.selectedProxy === true);

    };

    /**
     * Apply the multiselect options, which means making the proxied options permanent
     */
    vm.optionToggled = function () {
      vm.column.filterData.forEach((item) => {
        item.selected = item.selectedProxy;
      });

      vm.column.isAllSelected = vm.column.filterData.every((item) => item.selected);
      const value = vm.column.filterData.filter((item) => item.selected);
      submitFilter({value, activeFilterObj: {[vm.column.headerTitle]: !vm.column.isAllSelected} });
    };

    // radio
    vm.selectedOption = function (value) {
      submitFilter({value, activeFilterObj: {[vm.column.headerTitle]: true}});
    };

    // text, radio
    vm.reset = () => {
      vm.column.selectedRadioValue = null;
      submitFilter({ value: undefined, activeFilterObj: {[vm.column.headerTitle]: false }});
    };

    // text
    vm.submitText = () => {
      const value = vm.column.value;
      submitFilter({
        value: value && value.length > 0 ? value : undefined,
        activeFilterObj: { [vm.column.headerTitle]: vm.column.value.length > 0 } });
    };

    const submitFilter = ({ value, activeFilterObj }) => {
      vm.column.value = value;
      $scope.$sgTableCtrl.filterData({activeFilterObj});
    };

    vm.submit = submitFilter;
  }
})();
